import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import { TabKey } from '../../../../../utils/common';
import { IAdvancedAnalyticsApiPayload } from '../../../../../types/chart';
import ExtremeValues from '../Plot/ExtremeValues/ExtremeValues';

interface ExtremeValuesBoxProps {
  activePlotAnalytics: string | null;
  previewDatasetId: string;
  coordinates: number[];
  datasets: IBestDataset[];
  dateRange: any;
  enrichedMetadata: IEnrichedMetadata[];
  onUpdate: (payload: IAdvancedAnalyticsApiPayload) => void;
  extremeValuesImage: string;
  error: string;
  extremeValuesLinks: string[];
  pointName: string;
  updating: boolean;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  onDatasetChange: (value: string) => void;
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
}

const ExtremeValuesBox: React.FC<ExtremeValuesBoxProps> = ({
  activePlotAnalytics,
  previewDatasetId,
  coordinates,
  datasets,
  dateRange,
  enrichedMetadata,
  onUpdate,
  extremeValuesImage,
  error,
  extremeValuesLinks,
  pointName,
  updating,
  userInput,
  updateUserInput,
  onDatasetChange,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  isOfflineDataset
}) => {
  if (activePlotAnalytics !== 'Extreme Values' ) {
    return null;
  }

  return (
    <ExtremeValues
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      datasets={datasets}
      dateRange={dateRange}
      enrichedMetadata={enrichedMetadata}
      onUpdate={onUpdate}
      extremeValuesImage={extremeValuesImage}
      error={error}
      extremeValuesLinks={extremeValuesLinks}
      pointName={pointName}
      updating={updating}
      userInput={userInput}
      updateUserInput={updateUserInput}
      onDatasetChange={onDatasetChange}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      isOfflineDataset={isOfflineDataset}
    />
  );
};

export default ExtremeValuesBox;
